import { render, staticRenderFns } from "./ClickAndBuyFundraisingNumberForm.vue?vue&type=template&id=f07b93b0&scoped=true"
import script from "./ClickAndBuyFundraisingNumberForm.vue?vue&type=script&lang=js"
export * from "./ClickAndBuyFundraisingNumberForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07b93b0",
  null
  
)

export default component.exports